/**
 * Export all publicly available constructs when the package is being published.
 */
export { getIcon } from "@courses-pm2/icons/src/ts/utils/getIcon";
export { getIconFont } from "@courses-pm2/icons/src/ts/utils/getIconFont";
